<template>
    <div>
        <div v-if="list.length>0">
            <div @click="toDetails(item)" class="dynamic-item flex-between " v-for="item,i in list" :key="i">
                <div style="flex:1" class="hidden1">{{item.title}}</div>
                <div class="date">{{item.date}}</div>
            </div>
        </div>
        <el-empty v-else :image-size="200"></el-empty>
        <div class="pages" v-if="newTotal>0">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="10"
                layout="prev, pager, next, jumper"
                :total="newTotal">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        list:{
            type:Array,
            default:()=>{
                return []
            }
        },
        total:{
            type:Number,
            default:0
        }
    },
    watch:{
        total: {
            handler(newVal) {
                if (newVal) {
                    this.newTotal=newVal
                }
            },
            deep: true,
            immediate: true
        }
    },
    data(){
        return {
            currentPage:1,
            newTotal:0
        }
    },
    methods:{
        toDetails(data){
            this.$emit('click',data)
        },
        handleSizeChange(){

        },
        handleCurrentChange(index){
            this.currentPage=index
            this.$emit('changePage',index)
        }
    }
}
</script>

<style lang="less" scoped>
.dynamic-item{
    margin-top:12px;
    padding:0 16px;
    height: 54px;
    border: 1px solid #f3f1ef;
    font-size: 20px;
    color: #333333;
    cursor: pointer;
    .date{
        font-size: 20px;
        color: #666666;
        flex-shrink: 0;
        margin-left:10px;
    }
}
.pages{
    margin-top:34px;
    display: flex;
    justify-content: flex-end;
}
::v-deep .el-pager li.active{
    color: #ED9D26;
}
</style>